import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { isEmptyObj, jsonParse } from 'src/app/helper/class/utilityHelper';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UserApiService {
  constructor(private http: HttpClient) { }

  saveUser(data: any) {
    return lastValueFrom(this.http.post(`users/saveUser`, data));
  }

  isUnique(field: any, id: any) {
    return lastValueFrom(this.http.get(`users/isUnique/${field}/${id}`));
  }
  isEmailUnique(username: any) {
    return lastValueFrom(this.http.get(`users/isEmailUnique/${username}`));
  }
  // patientDetails(field: any, id: any) {
  //   return lastValueFrom(this.http.get(`${environment.apiUrl1}/users/isUnique/${field}/${id}`))
  // }

  getUserData(id: any) {
    return lastValueFrom(this.http.get(`users/getById/${id}`));
  }
  getAllUser(ev: any) {
    const lasyP = isEmptyObj(ev) ? '' : '/' + JSON.stringify(ev);
    return lastValueFrom(this.http.get(`users/getUserAll${lasyP}`));
  }
  upcomingAppointment(id: any) {
    const p = id ? `/${id}` : '';
    return lastValueFrom(this.http.get(`appointment/getTodaysAppointment${p}`)
    );
  }
  getAllInactive(ev: any) {
    const lasyP = isEmptyObj(ev) ? '' : '/' + JSON.stringify(ev);
    return lastValueFrom(this.http.get(`users/getAllInactive${lasyP}`));
  }

  getUserById(id: any) {
    return lastValueFrom(this.http.get(`users/getUserDetails/${id}`));
  }
  getUserByUserName(username: any) {
    return lastValueFrom(this.http.get(`users/getUserByUserName/${username}`));
  }
  deleteUser(id: any, data: any = {}) {
    return lastValueFrom(this.http.delete(`users/deleteUser/${id}`, { body: data }));
  }
  genToken(pid, id: any) {
    return lastValueFrom(this.http.get(`patient_visit/genToken/${pid}/${id}`));
  }
  editToken(tokenId: any, doctorId: any) {
    return lastValueFrom(this.http.get(`patient_visit/updateToken/${tokenId}/${doctorId}`));
  }
  makeActive(id: any) {
    return lastValueFrom(this.http.put(`users/makeActive/${id}`, {}));
  }
  getDashboardData() {
    return lastValueFrom(this.http.get(`dashboard/getData`));
  }
  getDoctorList() {
    return lastValueFrom(this.http.get(`get/doctor`));
  }
  getAppointmentList() {
    return lastValueFrom(this.http.get(`appointment/getTodaysAppointment`));
  }
  searchPatient(terms: any) {
    return lastValueFrom(this.http.get(`patient/search/${terms}`));
  }
  invoiceSearch(terms: any) {
    return lastValueFrom(this.http.get(`invoice/search/${terms}`));
  }
  treatmentSearch(id: any, field: any) {
    return lastValueFrom(this.http.get(`treatment/search/${id}/[${field}]`));
  }
  getTodayToken(id = 0) {
    return lastValueFrom(this.http.get(`patient_visit/getTodaysToken/${id}`));
  }

  userGetById(id: any) {
    return lastValueFrom(this.http.get(`users/getById/${id}`));
  }

  markAsComplete(id: any, data?: any) {
    return lastValueFrom(this.http.post(`appointment/markAsVisited/${id}`, data));
  }


}
